
function getFlavoriaLang(language : string) : "fi" | "en" {
    if (language == "fi" || language == "fi-FI")
        return "fi"
    else
        return "en"
}

export default getFlavoriaLang;